//BootstrapStarterHeader.jsx
import React, { useEffect } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';
import './WriterHeader.css';
import { getWriterMode, getColorMode, hideCardMenus } from './BootstrapStarterHeaderUtilities';
import ToolFileNameContainer from './ToolFileNameContainer';

const BootstrapStarterHeader = ({ writerMode, setWriterMode, colorMode, fileName, setFileName, tagLibraryCount }) => {
    // Function to request updated tag count from ToolTagManagerTool
    const requestTagCountUpdate = () => {
        console.log('Requesting tag count update...');
        window.dispatchEvent(new CustomEvent('requestTagCountUpdate'));
    };

    // Auto-request tag count update after 5 seconds on page load
    useEffect(() => {
        const autoRequestUpdate = () => {
            setTimeout(() => {
                requestTagCountUpdate();
            }, 5000);
        };

        autoRequestUpdate();
    }, []);
    // Check for tagLibraryCount prop on component initialization
    useEffect(() => {
        if (tagLibraryCount !== undefined) {
            console.log('Header initialized with tagLibraryCount:', tagLibraryCount);
        }
    }, [tagLibraryCount]);

    const ifToolSavedStylesContainerPositionHidden = async () => {
        // Wait for 2 seconds
        await new Promise(resolve => setTimeout(resolve, 50));

        // Step 1: Scan for <div id="appBodyToolStyles">
        const appBodyToolStyles = document.getElementById("appBodyToolStyles");

        if (appBodyToolStyles) {
            const displayStyle = window.getComputedStyle(appBodyToolStyles).display;

            // Step 2: Check if display is NOT 'none' or not defined
            if (displayStyle !== 'none') {
                // Step 3: Scan for <div id="toolSavedStylesContainerPosition">
                const container = document.getElementById("toolSavedStylesContainerPosition");

                if (container) {
                    const visibilityStyle = window.getComputedStyle(container).visibility;

                    // Step 4: If visibility is 'hidden', click <button id="buttonSavedStylesShow">
                    if (visibilityStyle === 'hidden') {
                        const showButton = document.getElementById("buttonSavedStylesShow");

                        if (showButton) {
                            showButton.click();
                        }
                    }
                }
            }
        }
    };

    const ifAppBodyToolStylesDisplayNoneFalse = () => {
        const appBodyToolStyles = document.getElementById("appBodyToolStyles");

        if (appBodyToolStyles) {
            const displayStyle = window.getComputedStyle(appBodyToolStyles).display;

            if (displayStyle !== 'none') {
                const buttonSavedStylesHide = document.getElementById("buttonSavedStylesHide");
                if (buttonSavedStylesHide) {
                    buttonSavedStylesHide.click();
                }
            }
        }
    };

    const mainMenuAppBodyToolsDivSuppressor = () => {
        setTimeout(() => {
            const mainMenuTitle = document.getElementById('mainMenuTitle');

            if (mainMenuTitle) {
                const appBodyColumnTools = document.getElementById('appBodyColumnTools');

                if (appBodyColumnTools) {
                    if (appBodyColumnTools.classList.contains('app-body-tools-container')) {
                        appBodyColumnTools.classList.remove('app-body-tools-container');
                        appBodyColumnTools.classList.add('app-body-tools-container-mainmenu');
                        console.log('mainMenuAppBodyToolsDivSuppressor: class switched to app-body-tools-container-mainmenu');
                    } else {
                        console.log('mainMenuAppBodyToolsDivSuppressor: app-body-tools-container class not present');
                    }
                } else {
                    console.log('mainMenuAppBodyToolsDivSuppressor: #appBodyColumnTools not found');
                }
            } else {
                console.log('mainMenuAppBodyToolsDivSuppressor: #mainMenuTitle not found');
            }
        }, 10);
    };


    const launchSendUI = () => {
        // Hide the bootstrap starter UI container
        const bootstrapContainer = document.getElementById('bootstrapStarterUIContainer');
        if (bootstrapContainer) {
            bootstrapContainer.style.display = 'none';
        }

        // Show the send UI container
        const sendContainer = document.getElementById('sendUIContainer');
        if (sendContainer) {
            sendContainer.style.display = 'block';
        }
    };

    return (
        <div className={`writer-header-container ${getWriterMode(writerMode)} ${getColorMode(colorMode)}`}>

            <Button
                id="hideCardMenusButton"
                className="hideCardMenusButton"
                style={{ display: 'none' }}

                onClick={async () => {
                    ifAppBodyToolStylesDisplayNoneFalse();
                    hideCardMenus();
                    window.dispatchEvent(new CustomEvent('toggleStylesTool'));
                    ifToolSavedStylesContainerPositionHidden();
                }}

            >Hide Card Menus
            </Button>


            <div id="headerTextBox" className="colorTest2">
                {/* Header Test Box */}
            </div>
            <div id="appHeaderBarContainer" className="blue">
                {/* <p>Header Container</p> */}
                <div id="appHeaderBarRow" className="row red textColorHeader">
                    {/* <p>Header Row HERE</p> */}
                    <div id="appHeaderBarColContainerLeft" className="container col-8 col-md-6 gray">

                        <div id="appHeaderBarColRowLeft" className="d-flex align-items-center">
                            <div
                                id="appHeaderBarColLeft-BoxLogoMenuLeft"
                                className="yellow d-flex justify-content-start align-items-center"
                                onClick={() => {
                                    window.dispatchEvent(new CustomEvent('toggleMainMenuTool'));
                                    mainMenuAppBodyToolsDivSuppressor();
                                }}
                            >
                                <div id="logoAndMenuImageBox" className="logoAndMenuImageBox">
                                    <img
                                        id="logoAndMenu"
                                        className="logo-responsive"
                                        alt="Logo and Menu"
                                    />
                                </div>
                            </div>
                            <div id="appHeaderBarColLeft-BoxDraftNamerRight" className="salmon flex-grow-1">
                                <div
                                    id="appHeaderBarColLeft-BoxDraftNamerRightText"
                                    className="appHeaderBarColLeft-BoxDraftNamerRightText"
                                >
                                    OneWriter <span style={{ fontSize: '0.65em', fontWeight: '500' }}>Ver 1.0</span></div>
                                <ToolFileNameContainer
                                    fileName={fileName}
                                    setFileName={setFileName}
                                />
                            </div>


                        </div>

                    </div>



                    <div
                        id="appHeaderBarColContainerRight"
                        className="container col-4 col-md-6 green appHeaderBarColContainerRight">

                        {/* Desktop container 1 of 1 */}
                        <div
                            id="appHeaderBarColRowRight"
                            className="d-flex flex-column flex-md-row appHeaderBarColRowRight">

                            {/* Mobile container 1 of 2 */}
                            <div className="headerButtonsMobileArrangeContainer1Of2">

                                {/* SEND (Mobile only) button with navigation */}
                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu0of5Mobile"
                                    className="my-1 salmon appHeaderBarColRight-BoxLogoMenu0of5">
                                    <Button
                                        id="appHeaderBarColRight-BoxLogoMenu5of5ButtonMobile"
                                        className="responsive-icon-button  appHeaderBarColRight-BoxLogoMenu5of5Button"
                                        onClick={() => {
                                            hideCardMenus();
                                            window.dispatchEvent(new CustomEvent('toggleSendTool'));

                                        }}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxImage"
                                            >
                                                <img
                                                    id="iconSend"
                                                    src="/SVGicons/send-black.svg"
                                                    alt="Send"
                                                />
                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxText headerTextMobileHide"
                                            >
                                                <span className="button-text">Send</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>

                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu1of5"
                                    className=" my-1 yellow appHeaderBarColRight-BoxLogoMenu1of5">
                                    <Button
                                        size="sm"
                                        id="appHeaderBarColRight-BoxLogoMenu1of5Button"
                                        className="responsive-icon-button appHeaderBarColRight-BoxLogoMenu1of5Button"
                                        onClick={() => {
                                            ifAppBodyToolStylesDisplayNoneFalse();
                                            hideCardMenus();
                                            window.dispatchEvent(new CustomEvent('toggleViewsTool'));
                                            ifToolSavedStylesContainerPositionHidden();
                                        }}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu1of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu1of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu1of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu1of5ButtonBoxImage"
                                            >
                                                <img
                                                    id="iconViews"
                                                    src="/SVGicons/views-black.svg"
                                                    alt="Views Manager"
                                                />
                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu1of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu1of5ButtonBoxText headerTextMobileHide"
                                            >
                                                <span className="button-text">Views</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>

                            </div>

                            {/* Mobile container 2 of 2 */}
                            <div className="headerButtonsMobileArrangeContainer2Of2">

                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu2of5"
                                    className="my-1 salmon appHeaderBarColRight-BoxLogoMenu2of5">
                                    <Button
                                        id="appHeaderBarColRight-BoxLogoMenu2of5Button"
                                        className="responsive-icon-button  appHeaderBarColRight-BoxLogoMenu2of5Button"
                                        onClick={() => {
                                            ifAppBodyToolStylesDisplayNoneFalse();
                                            hideCardMenus();
                                            window.dispatchEvent(new CustomEvent('toggleTagsTool'));
                                            ifToolSavedStylesContainerPositionHidden();
                                        }}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu2of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu2of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxImage"
                                            >



                                                <div
                                                    id="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxImageIconOverlayContainer"
                                                    className="tagLibraryManagerTitleContainerIconOverlayContainer"
                                                    style={{
                                                        position: 'relative',
                                                        width: '20px',
                                                        height: '20px'
                                                    }}
                                                >
                                                    <img
                                                        id="iconTags"
                                                        className="tagLibraryManagerTitleContainerIconOverlayContainerImg"
                                                        src={tagLibraryCount > 0 ? "/SVGicons/tag-black.svg" : "/SVGicons/tag-black.svg"}
                                                        alt="Tags Manager"
                                                        style={{
                                                            display: 'block',
                                                            width: '20px',
                                                            height: '20px'
                                                        }}
                                                    />

                                                    {tagLibraryCount > 0 && (
                                                        <div
                                                            id="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxImageIconOverlayContainerText"
                                                            className="tagLibraryManagerTitleContainerIconOverlayContainerText"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '45%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                width: '100%',
                                                                textAlign: 'center',
                                                                color: 'black',
                                                                backgroundColor: 'transparent',
                                                                fontSize: '8px',
                                                                fontWeight: 'bold',
                                                                lineHeight: '1',
                                                                whiteSpace: 'nowrap',
                                                                pointerEvents: 'none'
                                                            }}
                                                        >
                                                            {tagLibraryCount}
                                                        </div>
                                                    )}
                                                </div>





                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxText headerTextMobileHide"
                                            >
                                                <span className="button-text">Tags</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu3of5"
                                    className="my-1 yellow appHeaderBarColRight-BoxLogoMenu3of5">
                                    <Button
                                        id="appHeaderBarColRight-BoxLogoMenu3of5Button"
                                        className="responsive-icon-button  appHeaderBarColRight-BoxLogoMenu3of5Button"
                                        onClick={async () => {
                                            ifAppBodyToolStylesDisplayNoneFalse();
                                            hideCardMenus();
                                            window.dispatchEvent(new CustomEvent('toggleStylesTool'));
                                            ifToolSavedStylesContainerPositionHidden();
                                        }}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu3of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu3of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu3of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu3of5ButtonBoxImage"
                                            >
                                                <img
                                                    id="iconStyles"
                                                    src="/SVGicons/stylesindent-black.svg"
                                                    alt="Styles Manager"
                                                />
                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu3of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu3of5ButtonBoxText headerTextMobileHide"
                                            >
                                                <span className="button-text">Styles</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu4of5"
                                    className="my-1 yellow appHeaderBarColRight-BoxLogoMenu4of5">
                                    <Button
                                        id="appHeaderBarColRight-BoxLogoMenu4of5Button"
                                        className="responsive-icon-button  appHeaderBarColRight-BoxLogoMenu4of5Button"
                                        onClick={() => {
                                            ifAppBodyToolStylesDisplayNoneFalse();
                                            hideCardMenus();
                                            window.dispatchEvent(new CustomEvent('toggleFiltersTool'));
                                            ifToolSavedStylesContainerPositionHidden();

                                        }}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu4of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu4of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu4of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu4of5ButtonBoxImage"
                                            >
                                                <img
                                                    id="iconStyles"
                                                    src="/SVGicons/filters-black.svg"
                                                    alt="Filters Manager"
                                                />
                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu4of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu4of5ButtonBoxText headerTextMobileHide"
                                            >
                                                <span className="button-text">Filters</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                                {/* SEND (desktop only) button with navigation */}
                                <div
                                    id="appHeaderBarColRight-BoxLogoMenu5of5Desktop"
                                    className="my-1 salmon appHeaderBarColRight-BoxLogoMenu5of5">
                                    <Button
                                        id="appHeaderBarColRight-BoxLogoMenu5of5Button"
                                        className="responsive-icon-button  appHeaderBarColRight-BoxLogoMenu5of5Button"
                                        onClick={launchSendUI}
                                    >
                                        <div
                                            id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBox"
                                            className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBox"
                                        >
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxImage"
                                                className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxImage"
                                            >
                                                <img
                                                    id="iconSend"
                                                    src="/SVGicons/send-black.svg"
                                                    alt="Send"
                                                />
                                            </div>
                                            <div
                                                id="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxText"
                                                className="appHeaderBarColRight-BoxLogoMenu5of5ButtonBoxText"
                                            >
                                                <span className="button-text">Send</span>
                                            </div>
                                        </div>
                                    </Button>
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};
export default BootstrapStarterHeader;